/**
 *
 * AddPricePeriod
 *
 */

import React from 'react';
import { TopActionButton } from 'app/components/BasicButtons/TopActionButton';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { RenderPageType } from 'app/Layout/FrontendLayout/slice/type';
import { useDispatch } from 'react-redux';
import { useLayoutSlice } from 'app/Layout/FrontendLayout/slice';
import { RegionDetailsProps } from 'app/pages/Regions/RegionsDetailsPage/Details';

interface AddRegionProps {}

export function AddRegion(props: AddRegionProps): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { actions } = useLayoutSlice();

  //RENDER
  return (
    <React.Fragment>
      <TopActionButton
        text={t(translations.AddRegion) as string}
        icon="plus"
        startIcon="plus"
        onClick={() => {
          let params = {
            useSidePanel: true,
          } as RegionDetailsProps;
          dispatch(
            actions.openSidePanel({
              type: RenderPageType.RegionDetails,
              props: params,
            }),
          );
        }}
      />
    </React.Fragment>
  );
}
